import Model from './Model'
import Vehicle from './Vehicle'
export default class Customer extends Model {

    resource()
    {
        return 'customers'
    }

    vehicles() {
        return this.hasMany(Vehicle)
    }

    get types() {
        return [{
            text: 'Persoana Fizica (PF)',
            value: 'person'
        }, {
            text: 'Persoana Juridica (PJ)',
            value: 'company'
        }]
    }
}
